export default __webpack_public_path__ + "static/media/manalihome.98ebaf46.jpg";